import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const DownloadEmployeePdf = (employeeList, companyName, logo, setOpenBackdrop) => {
    const dataList = Array.isArray(employeeList) ? employeeList : [];

    if (dataList.length === 0) {
        alert("No employee data found to print!");
        return;
    }

    if (typeof setOpenBackdrop === 'function') {
        setOpenBackdrop(true);
    }

    const doc = new jsPDF('l', 'mm', 'a4'); 

    try {
        // --- 1. Header Section (Company Info) ---
        let hasValidLogo = false;

        // Safe Logo Handling to prevent jsPDF crash
        if (logo && typeof logo === 'string' && logo.trim() !== '') {
            try {
                // Agar Base64 format hai tabhi add karein
                if (logo.startsWith('data:image')) {
                    const format = logo.includes('image/jpeg') || logo.includes('image/jpg') ? 'JPEG' : 'PNG';
                    doc.addImage(logo, format, 14, 10, 15, 15);
                    hasValidLogo = true;
                }
            } catch (imgError) {
                console.warn("Logo rendering skipped due to format issue:", imgError);
            }
        }
        
        doc.setFontSize(18);
        doc.setTextColor(25, 118, 210); // Professional Blue
        doc.setFont("helvetica", "bold");
        doc.text(companyName || 'COMPANY NAME', hasValidLogo ? 35 : 14, 20);
        
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.setFont("helvetica", "normal");
        doc.text('EMPLOYEE REPORT', 230, 20);

        // Decorative Line
        doc.setDrawColor(200);
        doc.line(14, 28, 283, 28);

        // --- 2. Table Configuration ---
        const tableHeaders = [[
            'S.No', 
            'Emp Code', 
            'Employee Name', 
            'Mobile', 
            'Designation', 
            'Department', 
            'Status',
            'Site(s)'
        ]];

        const tableData = dataList.map((item, idx) => {
            const siteNames = Array.isArray(item.site_names) 
                ? item.site_names.join(', ') 
                : (item.site_names || '-');

            return [
                idx + 1,
                item.employee_code || '-',
                item.contact_name || item.fname || 'N/A',
                item.mobile || '-',
                item.designation_name || '-',
                item.department_name || '-',
                item.status === 1 ? 'Active' : 'Inactive',
                siteNames
            ];
        });

        // --- 3. Generate Table ---
        doc.autoTable({
            startY: 35,
            head: tableHeaders,
            body: tableData,
            theme: 'striped',
            headStyles: { 
                fillColor: [25, 118, 210], 
                textColor: [255, 255, 255],
                fontSize: 10,
                fontStyle: 'bold'
            },
            styles: { 
                fontSize: 9, 
                cellPadding: 3 
            },
            columnStyles: {
                0: { cellWidth: 12 }, 
                1: { cellWidth: 28 }, 
                2: { cellWidth: 45 }, 
                3: { cellWidth: 30 }, 
                4: { cellWidth: 35 }, 
                5: { cellWidth: 35 }, 
                6: { cellWidth: 20, halign: 'center' }, 
            },
            didDrawPage: () => {
                const pageCount = doc.internal.getNumberOfPages();
                doc.setFontSize(8);
                doc.setTextColor(150);
                doc.text(`Page ${pageCount}`, 283, 200, { align: 'right' });
                doc.text("Generated on: " + new Date().toLocaleString(), 14, 200);
            }
        });

        // --- 4. Finalize and Save ---
        const timestamp = new Date().getTime();
        const safeCompanyName = (companyName || 'Company').replace(/\s+/g, '_');
        doc.save(`${safeCompanyName}_Employee_Report_${timestamp}.pdf`);

    } catch (error) {
        console.error("PDF Generation Error:", error);
        alert("Something went wrong while generating the PDF");
    } finally {
        if (typeof setOpenBackdrop === 'function') {
            setOpenBackdrop(false);
        }
    }
};

export default DownloadEmployeePdf;